import { SaleUnitCartDto } from '@up/data';

export function getLastSaleUnitCartProductClickedSequence(
  currentClickedSequence,
  saleUnitCart: SaleUnitCartDto
) {
  let saleUniCartProductsWithClickedSequence = [];
  saleUniCartProductsWithClickedSequence = saleUnitCart.cart.cartProducts.filter((x) => x.clickedSequence);
  saleUniCartProductsWithClickedSequence?.forEach((x) => {
    if(x.clickedSequence > currentClickedSequence) {
      currentClickedSequence = x.clickedSequence;
    }
  })

  return currentClickedSequence;
}

export function getLastSaleUnitCartNoteClickedSequence(
  currentNoteClickedSequence,
  saleUnitCart: SaleUnitCartDto
) {
  let saleUniCartNotesWithClickedSequence = [];
  saleUniCartNotesWithClickedSequence = saleUnitCart.cart.cartNoteOptions.filter((x) => x.clickedSequence);
  saleUniCartNotesWithClickedSequence?.forEach((x) => {
    if(x.clickedSequence > currentNoteClickedSequence) {
      currentNoteClickedSequence = x.clickedSequence;
    }
  })

  return currentNoteClickedSequence;
}